import { gql } from '@apollo/client';

export const GET_WORK_PROGRESS_BAG_CUSTOMER_BREAKDOWN = gql`
  query GetWorkProgressBagCustomerBreakdown($filter: WorkProgressBagCustomerBreakdownFilterInput!) {
    getWorkProgressBagCustomerBreakdown(filter: $filter) {
      withMawb {
        mawb
        arrivalDate
        bagCount
        expectedBagCountSum
        inboundBagCountSum
        expectedParcelCountSum
        inboundParcelCountSum
        parcelDiffSum
        parcelDiffRate
      }
      noMawb {
        bagNumber
        arrivalDate
        expectedParcelCountSum
        inboundParcelCountSum
        parcelDiffSum
        parcelDiffRate
      }
    }
  }
`;

export interface WorkProgressBagCustomerBreakdownFilterInput {
  hubId: number;
  arrivalDateStart: string;
  arrivalDateEnd: string;
  customerId: number;
  /** true：当前大包预实差口径；false：二级只统计已入库大包 */
  showBagExpectedDiff?: boolean | null;
}

export interface WorkProgressBagCustomerMawbSummaryRow {
  mawb: string;
  arrivalDate: string;
  bagCount: number;
  expectedBagCountSum: number;
  inboundBagCountSum: number;
  expectedParcelCountSum: number;
  inboundParcelCountSum: number;
  parcelDiffSum: number;
  parcelDiffRate: number;
}

export interface WorkProgressBagCustomerNoMawbSummaryRow {
  bagNumber: string;
  arrivalDate: string;
  expectedParcelCountSum: number;
  inboundParcelCountSum: number;
  parcelDiffSum: number;
  parcelDiffRate: number;
}

export interface GetWorkProgressBagCustomerBreakdownResponse {
  getWorkProgressBagCustomerBreakdown: {
    withMawb: WorkProgressBagCustomerMawbSummaryRow[];
    noMawb: WorkProgressBagCustomerNoMawbSummaryRow[];
  };
}

